import PropTypes from "prop-types";
import React from "react";

import styles from "../../styles/components/TogglePageCardList.css";
import MiniPage from "../MiniPage";
import TogglePageCard from "./TogglePageCard";

export default class TogglePageCardList extends React.Component {
    static propTypes = {
        pages: PropTypes.arrayOf(
            PropTypes.shape({
                isSelected: PropTypes.bool.isRequired,
                ...MiniPage.pageShape
            })
        ),
        onTogglePage: PropTypes.func.isRequired
    };

    render = () => {
        const { pages, onTogglePage } = this.props;
        return (
            <ol className={styles.pageResultDetails}>
                {pages.map(page => (
                    <li key={page.id} className={styles.pageWrapper}>
                        <div className={styles.page}>
                            <TogglePageCard
                                isSelected={page.isSelected}
                                onToggleSelected={() => onTogglePage(page)}
                                page={page}
                            />
                        </div>
                    </li>
                ))}
            </ol>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/Results/TogglePageCardList.js